/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertPluginMappingRequest
 */
export interface UpsertPluginMappingRequest {
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: any; }}
     * @memberof UpsertPluginMappingRequest
     */
    config?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof UpsertPluginMappingRequest
     */
    refId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPluginMappingRequest
     */
    pluginId: string;
}

/**
 * Check if a given object implements the UpsertPluginMappingRequest interface.
 */
export function instanceOfUpsertPluginMappingRequest(value: object): value is UpsertPluginMappingRequest {
    if (!('pluginId' in value) || value['pluginId'] === undefined) return false;
    return true;
}

export function UpsertPluginMappingRequestFromJSON(json: any): UpsertPluginMappingRequest {
    return UpsertPluginMappingRequestFromJSONTyped(json, false);
}

export function UpsertPluginMappingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertPluginMappingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'config': json['config'] == null ? undefined : json['config'],
        'refId': json['refId'] == null ? undefined : json['refId'],
        'pluginId': json['pluginId'],
    };
}

export function UpsertPluginMappingRequestToJSON(value?: UpsertPluginMappingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'config': value['config'],
        'refId': value['refId'],
        'pluginId': value['pluginId'],
    };
}

